module.exports = __webpack_public_path__ + "fonts/MAYZm6M/.woff2";